import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import { Table, Form, Col, Button, Modal, Pagination } from "react-bootstrap"; // Import Pagination
import "./Project.css";
import { useAuth } from "../../ProtectedRoute/AppContext";
import AxiosInstance from "../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../Services/ProjectService";
import { useNavigate } from "react-router";
import { toast, ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import Loader from "../../DesignLayout/Loader/Loader";
const Projects = () => {
  const { user } = useAuth();
  const [Loading,setLoading]=useState(false);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newProject, setNewProject] = useState({
    projectName: "",
    createdBy: user?.userId || 0,
    description: "",
    assignTo: "",
   // dueDate: "",
  });

  const [currentPage, setCurrentPage] = useState(1); // For pagination
  const itemsPerPage = 15; // Number of items per page
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      if (!user?.sessionId) {
        console.warn("No sessionId available, skipping API call.");
        return;
      }

      try {
        console.log("Fetching projects for userId:", user.sessionId);
        const response = await AxiosInstance.get(
          `${API_ENDPOINTS.GET_PROJECTS_REPORT}?userId=${user.sessionId}`
        );

        if (response.data) {
          setUsers(response.data.users || []);

          const projects = response.data.projects || [];
          const projectsById = response.data.projectsById || [];

          if (projects.length > 0) {
            setProjects(projects);
            setFilteredProjects(projects);
          } else if (projectsById.length > 0) {
            setProjects(projectsById);
            setFilteredProjects(projectsById);
          } else {
            console.log("No projects found");
            setProjects([]);
            setFilteredProjects([]);
          }
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchProjects();
  }, [user.sessionId]);

  const handleSearch = () => {
    const updatedProjects = projects.filter((project) =>
      project.projectName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredProjects(updatedProjects);
   
    setCurrentPage(1); // Reset to first page
  };

  useEffect(() => {
  
    handleSearch();
  }, [searchQuery, projects]);

  const handleProjectClick = (projectId) => {
  
      navigate("/projectdetails", { state: { projectId } });
   
  };

  const AddProject = async (e) => {
    console.log(users)
    e.preventDefault();
    setLoading(true);
    try {
      console.log(newProject)
      const response = await AxiosInstance.post(API_ENDPOINTS.POST_PROJECTS, newProject);
      
      if (response.data) {
        
      
        sessionStorage.setItem("projectMessage","Project created successfully")
        setShowModal(false);
        setNewProject({
          projectName: "",
          createdBy: user?.userId || 0,
          description: "",
          assignTo: "",
         // dueDate: "",
        });
        window.location.reload();
      } else {
        sessionStorage.setItem("projectMessage","Failed creating project.");
        window.location.reload();
      }
    } catch (error) {
      sessionStorage.setItem("projectMessage","Invalid project details.");
      window.location.reload();
    }finally{
      setLoading(false);
    }
  };

   window.onload = () => {
      const message = sessionStorage.getItem("projectMessage");
      if (message) {
          toast.success(message);
          sessionStorage.removeItem("projectMessage"); // Clear after showing
      }
  };

// Handle selection
const onUserSelect = (selectedList) => {
  // Join selected user ids into a comma-separated string
  const selectedUserIds = selectedList.map((item) => item.userId).join(',');
  setNewProject((prevTask) => ({
    ...prevTask,
    assignTo: selectedUserIds, // Store as a string
  }));
};

// Handle removal
const onUserRemove = (selectedList) => {
  // Join remaining selected user ids into a comma-separated string
  const selectedUserIds = selectedList.map((item) => item.userId).join(',');
  setNewProject((prevTask) => ({
    ...prevTask,
    assignTo: selectedUserIds, // Store as a string
  }));
};
  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  // Pagination logic
  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
  const currentProjects = filteredProjects.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="project-page">
        <ToastContainer/>
        <Loader loading={Loading} />
      <div className="box">
        <div className="d-flex mb-3">
          <Col md={3}>
          <Form.Control
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Project Name"
            />
          </Col>
          {(user.permission.includes(7)===true||user.permission.includes(10)===true||user.role===1 || user.role===2 || user.role===5)&&(
          <Col md={2}>
            <Button className="btn btn-primary w-100" onClick={handleModalShow}>
              Create Project
            </Button>
          </Col>
          )}
        </div>

        <Table striped bordered hover responsive className="shadow-sm mt-3">
          <thead className="table-primary">
            <tr>
              <th>Project ID</th>
              <th>Project Name</th>
              <th>Created By</th>
              <th>Description</th>
              <th>Start Date </th>
              <th>Assigned To</th>
              <th>Due Date</th>
            </tr>
          </thead>
          <tbody>
            {currentProjects.map((project) => (
              <tr
                key={project.projectId}
                onClick={() => handleProjectClick(project.projectId)}
                style={{ cursor: "pointer" }}
              >
             
                <td>PR-{project.projectId}</td>
                <td>{project.projectName}</td>
                <td>{project.createdBy}</td>
                <td>{project.description} </td>
                <td>{new Date(project.createdDate).toISOString().split("T")[0]}</td>
                <td>{project.assignTo}</td>
                <td>{new Date(project.dueDate).toISOString().split("T")[0]}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* Pagination */}
        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>

      {/* Modal for Creating New Project */}
      <Modal show={showModal} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Create New Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={AddProject}>
            <Form.Group>
              <Form.Label>Project Name</Form.Label>
              <Form.Control
                type="text"
                className="text-start"
                value={newProject.projectName}
                onChange={(e) => setNewProject({ ...newProject, projectName: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                className="text-start"
                rows={3}
                value={newProject.description}
                onChange={(e) => setNewProject({ ...newProject, description: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Assigned To</Form.Label>
              <Multiselect
                className="text-start"
                options={users}
                displayValue="userName"
                onSelect={onUserSelect}
                onRemove={onUserRemove}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                type="date"
                value={newProject.dueDate}
                onChange={(e) => setNewProject({ ...newProject, dueDate: e.target.value })}
               // required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              Save Project
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Projects;
